import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

export const SignupButtonStyle = styled.button`
  width: 100%;
  height: 48px;
  padding: 8px 16px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border: 1px solid ${designTokens.colors.line.button};
  color: ${designTokens.colors.font.tertiary};
  ${getTypography("korean", "body3")}

  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f8f9fa;
  }

  &:disabled {
    background-color: rgb(249, 249, 249);
    color: #adb5bd;
    cursor: not-allowed;
    border-color: #dee2e6;
  }

  img {
    width: 20px;
  }

  span {
    flex-grow: 1;
  }
`;

export const PrevButton = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  height: 40px;
  flex-grow: 1;

  background: #ffffff;
  border: 1px solid #dbdce2;
  border-radius: 6px;

  ${getTypography("korean", "body2")}
  color: ${designTokens.colors.font.primary};

  cursor: pointer;

  &:disabled {
    background: #e0e0e0;
    color: #a0a0a0;
    border-color: #e0e0e0;
    cursor: not-allowed;
  }
`;

export const NextButton = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  height: 40px;
  flex-grow: 1;

  background: #000000;
  border-radius: 6px;
  border: 1px solid #000000;

  ${getTypography("korean", "body2")}
  color: white;

  cursor: pointer;

  &:disabled {
    background: #e0e0e0;
    color: #a0a0a0;
    border-color: #e0e0e0;
    cursor: not-allowed;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;
  width: 100%;
  max-width: 456px;
`;
